import { IAppStore } from '@/models/store.model'
import { webApiService } from '@/services'
import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from '@nextui-org/react'
import { enqueueSnackbar } from 'notistack'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { useTradeinContext } from '../hooks/useTradeinContext'

const AddContribution = () => {
  const [data, setData] = useState<{ visible: boolean, open: boolean, contribution: any, loading: boolean}>({ visible: false, open: false, loading: false, contribution: null })
  const { slug } = useParams()
  const { ctx, saveCtx } = useTradeinContext()
  const userState = useSelector((store: IAppStore) => store.user)

  const getCampaign = () => {
    webApiService.activeContribution({ seller: String(slug), idSbu: 0, idBrand: 0, idModel: 0 }).then(res => {
      if (res.data !== null) {
        setData({ ...data, contribution: res.data, visible: true })
      }
    }).catch((error: any) => {
      console.log(error)
      enqueueSnackbar(error.message, { variant: 'error' })
    })
  }

  const handleClose = () => {
    setData({ ...data, open: false })
  }

  const handleAddContribution = () => {
    setData({ ...data, loading: true })
    webApiService.update({
      stage: 11,
      id_tradein: ctx.tradein.id,
      id_contribution: data.contribution.id,
      contribution_amount: data.contribution.amount,
      user_id: userState.id
    })
      .then(() => {
        enqueueSnackbar('Campaña agregada', { variant: 'success' })
      })
      .catch((error) => {
        enqueueSnackbar('Hubo un error al intentar guardar el registro.', { variant: 'error' })
        console.log('error ==>', error)
      }).finally(() => {
        saveCtx({ ...ctx, reload: true })
        setData({ ...data, open: false, loading: false })
      })
  }

  useEffect(() => {
    getCampaign()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div hidden={ctx.tradein.id_status !== 4 || !data.visible || (ctx.tradein.id_contribution !== null && ctx.tradein.id_contribution !== 0)}>
      <Button
        variant='secondary'
        size='sm'
        legacyColor='warning'
        legacyVariant='shadow'
        legacyClassName='text-white'
        onClick={() => { setData({ ...data, open: true }) }}
      >
        Campaña disponible
      </Button>
      <Modal isOpen={data.open} onClose={handleClose}>
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader />
              <ModalBody>
                <div className='text-center'>
                  <h3>Se encuentra activa la campaña: </h3>
                  <h1 className='text-xl'><strong>{data.contribution.name}</strong></h1>
                  <p className='mt-4 text-sm'>Pincha en <strong>"Agregar</strong> para sumar monto de campaña al tradein.</p>
                </div>

              </ModalBody>
              <ModalFooter>
                <Button
                  size='sm'
                  variant='destructive'
                  onClick={onClose}
                >
                  Cerrar
                </Button>
                <Button size='sm' type='submit' disabled={data.loading} onClick={handleAddContribution}>
                  {data.loading ? 'Agregando...' : 'Agregar'}
                </Button>
              </ModalFooter>
            </>
          )}

        </ModalContent>
      </Modal>
    </div>
  )
}

export default AddContribution
